module.exports = __webpack_public_path__ + "media/Audio15_h.e8f25019.wav";